import { CaptureGate } from '@/pages/inspection/capture/CaptureGate';
import { createFileRoute } from '@tanstack/react-router';

function CaptureRoute() {
	const { inspectionId } = Route.useParams();
	return <CaptureGate inspectionId={inspectionId} />;
}

export const Route = createFileRoute('/_authenticated/_app/inspection/inspections/$inspectionId/capture')({
	component: CaptureRoute,
});
